import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { HOST_NAME_LOCAL } from '../../constants';
import { getLangSite, isLocalEnvironment, validateSiteLang } from '../../ultils';

const langSiteObj = getLangSite('us');

const country = langSiteObj.site;
const lang =  langSiteObj.lang;

// ! remove i18Key in localStorage 
const countryPrevious = `i18next_res_${country}-translation`;

localStorage.removeItem(countryPrevious);

const getResources = async () => {
  const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
  const response = await fetch(
  `${HOST_NAME}/en/cross-reference/api/internal/GetResourceFromLanguage`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, text/html',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify({
        Language: lang,
        Country: country
      })
    }
  );
  return response.json();
};

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: country,
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          expirationTime: parseInt(
            process.env.REACT_APP_TIME_EXPIRED_I18N || '0'
          )
        },
        {
          request: async (
            url: string,
            options: any,
            payload: any,
            callback: any
          ) => {
            try {
              validateSiteLang();
              const result = await getResources();
              callback(null, {
                data: result,
                status: 200
              });
            } catch (e) {
              console.log(url, options, payload);
            }
          }
        }
      ]
    },
    debug: false,
    react: {
      useSuspense: false
    }
  });

export default i18n;
